<template>
    <div v-if="props.activeNo == 0">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="4" class="table-data table-head">{{ $t('common.level') }}</van-col>
                <van-col span="4" class="table-data table-head">{{ $t('vip.bets') }}</van-col>
                <van-col span="4" class="table-data table-head">{{ $t('vip.upgradeBonus') }}</van-col>
                <van-col span="4" class="table-data table-head" v-if="activeData?.isDailyReward === 1">{{ $t('vip.dailyBonus')
                    }}</van-col>
                <van-col span="4" class="table-data table-head" v-if="activeData?.isWeeklyRewards === 1">{{ $t('vip.weeklyBonus')
                    }}</van-col>
                <van-col span="4" class="table-data table-head" v-if="activeData?.isMonthlyRewards === 1">{{ $t('vip.monthlyBonus')
                    }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between">
                <van-col span="4" class="table-data" style="color: #f8e400;">{{ $t('vip.title') }}
                    {{ item.level }}</van-col>
                <van-col span="4" class="table-data" style="color: #ffa600;">{{ item.bet_min }}</van-col>
                <van-col span="4" class="table-data">{{ item.upgrade_bonus ? item.upgrade_bonus : '--' }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isDailyReward === 1">{{ item.daily_reward ?
                    item.daily_reward : '--' }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isWeeklyRewards === 1">{{ item.week_reward ?
                    item.week_reward : '--' }}</van-col>
                <van-col span="4" class="table-data" v-if="activeData?.isMonthlyRewards === 1">{{ item.month_reward ?
                    item.month_reward : '--'
                    }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
    <div v-else-if="props.activeNo == 1">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="4" class="table-data table-head">{{ $t('common.level') }}</van-col>
                <van-col span="6" class="table-data table-head" v-if="activeData?.isDailyReward === 1">{{ $t('vip.dailyBonus')
                    }}</van-col>
                <van-col span="8" class="table-data table-head" v-if="activeData?.isWeeklyRewards === 1">{{ $t('vip.weeklyBonus')
                    }}</van-col>
                <van-col span="6" class="table-data table-head" v-if="activeData?.isMonthlyRewards === 1">{{ $t('vip.monthlyBonus')
                    }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between">
                <van-col span="4" class="table-data" style="color: #f8e400;">{{ $t('vip.title') }}
                    {{ item.level }}</van-col>
                <van-col span="6" class="table-data" v-if="activeData?.isDailyReward === 1" style="color: #ffa600;">{{
                    item.daily_reward_retention }}</van-col>
                <van-col span="8" class="table-data" v-if="activeData?.isWeeklyRewards === 1">{{
                    item.week_reward_retention }}</van-col>
                <van-col span="6" class="table-data" v-if="activeData?.isMonthlyRewards === 1">{{
                    item.month_reward_retention }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
</template>
<script setup lang="ts">
import NoData from '@/themes/themeTwo/components/common/noData.vue';
import { defineProps } from 'vue';

const props = defineProps({
    activeNo: {
        type: Number,
        required: true
    },
    tableData: {
        type: Array as () => any,
        required: false
    },
    activeData: {
        type: Object
    }
})
</script>
<style scoped>
.table-row {
    padding: 10px 0;
    font-size: 14px;
    background: #ffffff0a;
    margin-bottom: 2px;
}

.table-data {
    align-items: center;
    text-align: center;
    color: #86718c;
    font-size: 12px;
    font-weight: 100;
    padding: 0px 5px;
}
.table-head{
    color: #ffcef4;
}

.table-container {
    background: transparent;
    border-radius: 12px;
    /* max-width: 400px; */
    font-family: sans-serif;
    color: white;
    margin-top: 20px;
}

.table-header {
    font-size: 10px;
    padding: 10px 0px;
    background: #ffffff14;
    border-radius: 15px 15px 0px 0px;
    align-items: center;
}

@media (min-width: 450px) {
    .table-data {
        font-size: 14px;
    }
}
</style>